import { RegconRegister } from "@entity/domain/models/quality-framework/regcon-register/regcon-register.model";

export class CreateRegconRegister {
    constructor(
        public registerNumber: RegconRegister["registerNumber"],
        public registeredCcaa: RegconRegister["registeredCcaa"],
        public entity: RegconRegister["entity"],
    ) {}
}
